<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="flex items-center justify-between px-6 mt-6">
      <h4>{{ Object.entries(this.data).length === 0 ? "Create New" : "Update" }} Package</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <ValidationObserver v-slot="{ invalid }">
      <component
        :is="scrollbarTag"
        class="scroll-area--data-list-add-new"
        :settings="settings"
        :key="$vs.rtl"
      >
        <div class="p-6">
          <!-- Title -->
          <ValidationProvider
            immediate
            name="title"
            rules="required|alpha_spaces|min:3|max:100"
            v-slot="{ errors }"
          >
            <vs-input
              name="title"
              icon-no-border
              icon="icon icon-package"
              icon-pack="feather"
              label="Package Title"
              placeholder="Ex: Free"
              v-model="dataTitle"
              class="w-full special-form"
              :success="errors.length === 0"
              success-text="Package's title is valid"
              :danger="errors.length > 0"
              :danger-text="errors[0]"
            />
          </ValidationProvider>

          <!-- Simulation Size -->
          <ValidationProvider
            immediate
            name="simulation-count"
            rules="required|between:-1,999999999999"
            v-slot="{ errors }"
          >
            <vs-input
              name="simulation-count"
              icon-no-border
              icon="icon icon-activity"
              icon-pack="feather"
              label="How many simulations can user create per month? (-1 to unlimited)"
              v-model="dataSimulationCount"
              class="w-full special-form"
              :success="errors.length === 0"
              success-text="Simulation count is valid"
              :danger="errors.length > 0"
              :danger-text="errors[0]"
            />
          </ValidationProvider>

          <!-- Mitre Attack Size -->
          <ValidationProvider
            immediate
            name="mitre-size"
            rules="required|between:-1,999999999999"
            v-slot="{ errors }"
          >
            <vs-input
              name="mitre-size"
              icon-no-border
              icon="icon icon-list"
              icon-pack="feather"
              label="How many mitre attack techniques can user select per simulation? (-1 to unlimited)"
              v-model="dataMitreSize"
              class="w-full special-form"
              :success="errors.length === 0"
              success-text="Mitre Attack size is valid"
              :danger="errors.length > 0"
              :danger-text="errors[0]"
            />
          </ValidationProvider>

          <!-- Valid For -->
          <ValidationProvider
            immediate
            name="valid-for"
            rules="required|between:-1,999999999999"
            v-slot="{ errors }"
          >
            <vs-input
              name="valid-for"
              icon-no-border
              icon="icon icon-archive"
              icon-pack="feather"
              label="How many days can user download the malware file and update logs? (-1 to license time)"
              v-model="dataValidFor"
              class="w-full special-form"
              :success="errors.length === 0"
              success-text="Valid for field is valid"
              :danger="errors.length > 0"
              :danger-text="errors[0]"
            />
          </ValidationProvider>

          <!-- Monthly Cost -->
          <ValidationProvider
            immediate
            name="monthly-cost"
            rules="required|between:-1,999999999999"
            v-slot="{ errors }"
          >
            <vs-input
              name="monthly-cost"
              icon-no-border
              icon="icon icon-dollar-sign"
              icon-pack="feather"
              label="Monthly Cost"
              v-model="dataMonthlyCost"
              class="w-full special-form"
              :success="errors.length === 0"
              success-text="Montly cost field is valid"
              :danger="errors.length > 0"
              :danger-text="errors[0]"
            />
          </ValidationProvider>

          <!-- Yearly Cost -->
          <ValidationProvider
            immediate
            name="yearly-cost"
            rules="required|between:-1,999999999999"
            v-slot="{ errors }"
          >
            <vs-input
              name="yearly-cost"
              icon-no-border
              icon="icon icon-dollar-sign"
              icon-pack="feather"
              label="Yearly Cost"
              v-model="dataYearlyCost"
              class="w-full special-form"
              :success="errors.length === 0"
              success-text="Yearly cost field is valid"
              :danger="errors.length > 0"
              :danger-text="errors[0]"
            />
          </ValidationProvider>

          <p class="mt-5 mb-2 text-lg">Extra Features</p>
          <hr />

          <div class="w-full special-form">
            <vs-checkbox
              v-model="dataTechnicalSupport"
              class="mt-5 text-sm"
            >We'll provide technical support for this package.</vs-checkbox>

            <vs-checkbox
              v-model="dataBlueTeam"
              class="mt-5 text-sm"
            >We'll provide blue team module for this package.</vs-checkbox>
          </div>

          <vs-alert :active="isError" class="mt-5" color="danger" icon="new_releases">
            <span>{{error_message}}</span>
          </vs-alert>
        </div>
      </component>
      <div class="flex flex-wrap items-center p-6" slot="footer">
        <vs-button
          class="mr-6"
          @click="updatePackage"
          :disabled="invalid"
          v-if="dataId !== ''"
        >Update</vs-button>
        <vs-button class="mr-6" @click="createPackage" :disabled="invalid" v-else>Create</vs-button>
        <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
      </div>
    </ValidationObserver>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import eventBus from '../../eventBus'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar
  },
  data () {
    return {
      isError: false,
      error_message: '',
      dataId: '',
      dataTitle: '',
      dataSimulationCount: 0,
      dataMitreSize: 0,
      dataValidFor: 0,
      dataMonthlyCost: 0,
      dataTechnicalSupport: false,
      dataBlueTeam: false,
      dataYearlyCost: 0,
      dataCreatedAt: '',
      dataUpdatedAt: '',
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      }
    }
  },
  watch: {
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
      } else {
        // Edit comes here
        const {
          _id,
          title,
          simulationCount,
          mitreSize,
          validFor,
          technicalSupport,
          blueTeam,
          monthlyCost,
          yearlyCost,
          createdAt,
          updatedAt
        } = JSON.parse(JSON.stringify(this.data))
        this.dataId = _id
        this.dataTitle = title
        this.dataSimulationCount = simulationCount
        this.dataMitreSize = mitreSize
        this.dataValidFor = validFor
        this.dataTechnicalSupport = technicalSupport
        this.dataBlueTeam = blueTeam
        this.dataMonthlyCost = monthlyCost
        this.dataYearlyCost = yearlyCost
        this.dataCreatedAt = createdAt
        this.dataUpdatedAt = updatedAt
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          this.initValues()
        }
      }
    },
    scrollbarTag () {
      return this.$store.getters.scrollbarTag
    }
  },
  methods: {
    initValues () {
      if (this.data.id) return
      this.dataId = ''
      this.dataTitle = ''
      this.dataSimulationCount = 0
      this.dataValidFor = 0
      this.dataMitreSize = 0
      this.dataTechnicalSupport = false
      this.dataBlueTeam = false
      this.dataMonthlyCost = 0
      this.dataYearlyCost = 0
      this.dataCreatedAt = ''
      this.dataUpdatedAt = ''
    },
    isEmpty (val) {
      if (val === null || val === '' || val === undefined) {
        return true
      }
      return false
    },
    checkForm () {
      let errors = false
      if (this.isEmpty(this.dataId) || this.isEmpty(this.dataTitle)) {
        errors = true
      }
      return errors
    },
    updatePackage () {
      if (!this.checkForm()) {
        const data = {
          _id: this.dataId,
          title: this.dataTitle,
          simulationCount: this.dataSimulationCount,
          validFor: this.dataValidFor,
          mitreSize: this.dataMitreSize,
          technicalSupport: this.dataTechnicalSupport,
          blueTeam: this.dataBlueTeam,
          monthlyCost: this.dataMonthlyCost,
          yearlyCost: this.dataYearlyCost
        }
        this.$http
          .put('/management/packages', data)
          .then((res) => {
            eventBus.$emit('refresh-packages')
            if (res.data.status === true) {
              this.$emit('closeSidebar')
              this.initValues()
              this.$swal({
                position: 'bottom-start',
                icon: 'success',
                toast: true,
                title: 'Package successfully updated.',
                showConfirmButton: false,
                timer: 1500,
                timerProgressBar: true
              })
            } else {
              this.$swal({
                position: 'bottom-start',
                icon: 'error',
                toast: true,
                title: 'Error occurred updating the package.',
                showConfirmButton: false,
                timer: 1500,
                timerProgressBar: true
              })
            }
          })
          .catch((err) => {
            this.$swal({
              position: 'bottom-start',
              icon: 'error',
              toast: true,
              title: 'Error occurred updating the package.',
              showConfirmButton: false,
              timer: 1500,
              timerProgressBar: true
            })
          })
      } else {
        this.error_message = 'Please make sure form is correct.'
        this.isError = true
      }
    },
    createPackage () {
      const data = {
        title: this.dataTitle,
        simulationCount: this.dataSimulationCount,
        validFor: this.dataValidFor,
        mitreSize: this.dataMitreSize,
        technicalSupport: this.dataTechnicalSupport,
        blueTeam: this.dataBlueTeam,
        monthlyCost: this.dataMonthlyCost,
        yearlyCost: this.dataYearlyCost
      }
      this.$http
        .post('/management/packages', data)
        .then((res) => {
          eventBus.$emit('refresh-packages')
          if (res.data.status === true) {
            this.$emit('closeSidebar')
            this.initValues()
            this.$swal({
              position: 'bottom-start',
              icon: 'success',
              toast: true,
              title: 'Package successfully created.',
              showConfirmButton: false,
              timer: 1500,
              timerProgressBar: true
            })
          } else {
            this.$swal({
              position: 'bottom-start',
              icon: 'error',
              toast: true,
              title: 'Error occurred creating the package.',
              showConfirmButton: false,
              timer: 1500,
              timerProgressBar: true
            })
          }
        })
        .catch((err) => {
          this.$swal({
            position: 'bottom-start',
            icon: 'error',
            toast: true,
            title: 'Error occurred creating the package.',
            showConfirmButton: false,
            timer: 1500,
            timerProgressBar: true
          })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.special-form {
  margin-top: 0.5rem;
}
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>